import axios from "axios";
import { useNavigate } from "react-router-dom";
import ToastMessages from "../../Components/ToastMessages/ToastMessages";
import { toast } from "react-toastify";
import { ErrorAction } from "../Errors/Action";
import { headers, responseError, Login, SignUp, Contact, ForgotPassword, ProfileUpdate, headersWithImage, headersWithToken, ChangePassword, ShowTicker, ShowPodcast, ShowBlog, showTestimonial, ShowFreeTips, site_url, ShowPremiumTips, logoutDelToken, ShowPackages, showCategory, addCard, subscribe_url, cancelSubscription, UpgradeSubs, ResetPassword, infoAfterLogin, newsLetterUrl, getSiteMap, SiteSettingsUrl, CurrentSubsUrl, renewVenmoUrl, } from "../services/Apis";
import { showLoader } from "../services/Loader";
import { AFTER_LOGIN, REMEMBER_ME, SAVE_TOKEN, SIGN_UP, UPDATE_PROFILE } from '../services/Types';

export const incNumber = () => {
    // console.log("Incnum works");
    return {
        type: "INC"
    }
}

export const decNumber = () => {
    // console.log("DEC Works");
    return {
        type: "DEC"
    }
}

export const saveInfo = (token, userInfo, checked, password, activePackage) => {
    // console.log("save token from action auth", password);
    return {
        type: SAVE_TOKEN,
        payload: { token, userInfo, checked, password, activePackage }
    }
}

export const saveAfterLoginInfo = (activePackage) => {
    // console.log('naaaaaaaa', activePackage)
    return {
        type: AFTER_LOGIN,
        payload: activePackage,
    }
}

export const delPackage = () => {
    return {
        type: "DEL_PACKAGE"
    }
}
// maaz

export const UpdateProfileData = (e) => {
    // console.log("update profile data auth action", data)
    return {
        type: UPDATE_PROFILE,
        payload: { e }
    }
}

export const setProfile = (e) => {
    return {
        type: "SET_PROFILE",
        payload: e
    }
}

export const getAllProducts = (e) => {
    return {
        type: "GET_ALL_PROFILE",
        payload: e
    }
}

export const singleProduct = (e) => {
    return {
        type: "SINGLE_PRODUCT",
        payload: e
    }
}

export const addToCart = (e) => {
    // console.log('from action page', e)
    return {
        type: "ADD_TO_CART",
        payload: e
    }
}

export const delToCart = (e) => {
    return {
        type: "DEL_FROM_CART",
        payload: e
    }
}

export const RemeberMe = (e) => {
    // console.log("data recieved",e)
    return {
        type: `REMEMBER_ME`,
        payload: { e }
    }
}


// info after login

export const InfoAfterLogin = (user_tok) => {
    showLoader("flex");
    return (dispatch) => new Promise(async (myResolve, myReject) => {
        try {
            let res = await axios.get(infoAfterLogin, headersWithToken(user_tok))
            myResolve(res);
            showLoader("none");
            // console.log("daaaaaaaaaaaa",res.data.response.data.activePackage);
            dispatch(saveAfterLoginInfo(res?.data?.response?.data?.activeSubscription))
        } catch (e) {
            // myReject(e);
            // let errorHandler = responseError(e);
            // dispatch(ErrorAction(errorHandler));
            showLoader("none");
        }
    })
}

// save user info remember me

export const saveDetails = (data) => {
    // console.log('from auth action', data);
    return (dispatch) => new Promise(async (myResolve, myReject) => {
        try {
            dispatch(RemeberMe(data))
            myResolve(true);
        } catch (e) {
            myReject(false);
        }
    })
}

// cancel subscription api
export const CancelSubscriptionApi = (header) => {
    showLoader("flex");
    return (dispatch) => new Promise(async (myResolve, myReject) => {
        try {
            let res = await axios.get(UpgradeSubs, headersWithToken(header))
            myResolve(res);
            showLoader("none");
            dispatch(dispatch({
                type: "DEL_PACKAGE"
            }));
        } catch (e) {
            myReject(e);
            let errorHandler = responseError(e);
            dispatch(ErrorAction(errorHandler));
            showLoader("none");
        }
    })
}


// login api starts
export const LoginApi = (data, checked) => {
    // console.log('from auth service', data?.password);
    showLoader('flex');
    return (dispatch) => new Promise(async (myResolve, myReject) => {
        try {
            let res = await axios.post(`${Login}`, data, headers)
            // console.log("response from login", res);
            dispatch(saveInfo(res.data.response.data.token, res.data.response.data.user, checked, data?.password, res.data.response.data.activePackage))
            myResolve(true);
            showLoader('none');
        } catch (e) {
            let errorHandler = responseError(e);
            showLoader('none');
            console.log("Error found");
            dispatch(ErrorAction(errorHandler));
            myReject(false);
        }
    })
};

// update profile api starts

export const UpdateProfile = (data, token) => {
    // console.log('from contact api', token);
    showLoader('flex');
    return (dispatch) => new Promise(async (myResolve, myReject) => {
        try {
            let res = await axios.post(`${ProfileUpdate}`, data, headersWithImage(token));
            // console.log("response from update profile", res);
            dispatch(UpdateProfileData(res.data.response.data));
            showLoader("none");
            myResolve(true);
        } catch (e) {
            showLoader('none');
            console.log(e, ' from upate profile api');
            let errorHandler = responseError(e);
            dispatch(ErrorAction(errorHandler));
            myReject(false);
        }
    })
}

// add card api

export const PaymentApi = (data, user_token) => {
    // console.log("data", data);
    // console.log("tokenId", user_token);
    showLoader("flex");
    return (dispatch) => new Promise(async (myResolve, myReject) => {
        try {
            let res = await axios.post(addCard, data, headersWithToken(user_token));
            myResolve(res);
            toast.success("Card Added Successfully");
            showLoader("none");
        } catch (e) {
            console.log('error from auth action', e);
            let errorHandler = responseError(e);
            dispatch(ErrorAction(errorHandler));
            myReject(e);
            showLoader("none");
        }
    })
}

// subscribe api

export const SubscribeApi = (data, user_token, type) => {
    // console.log("data", data);
    // console.log("userToken", user_token);
    showLoader("flex");
    return (dispatch) => new Promise(async (myResolve, myReject) => {
        try {
            let res = await axios.post(type === "venmo-renew" ? renewVenmoUrl : subscribe_url, data, headersWithToken(user_token))
            myResolve(res);
            showLoader("none");
        } catch (e) {
            myReject(e);
            console.log("erroe", e);
            let errorHandler = responseError(e);
            dispatch(ErrorAction(errorHandler));
            showLoader("none");
        }
    })
}

// upgrade subscribe

export const UpgradeSubscriptionApi = (data, token) => {
    // console.log("data");
    showLoader("flex");
    return (dispatch) => new Promise(async (myResolve, myReject) => {
        try {
            let res = await axios.post(cancelSubscription, data, headersWithToken(token))
            // dispatch(UpdatePackInfo(res?.data?.response?.data));
            myResolve(res);
            showLoader("none");
        } catch (e) {
            myReject(e);
            let errorHandler = responseError(e);
            dispatch(ErrorAction(errorHandler));
        }
    })
}


// singup api starts

export const SignupApi = (data) => {
    // console.log("from signup api", data);
    showLoader('flex');
    return (dispatch) => new Promise(async (myResolve, myReject) => {
        try {
            let res = await axios.post(SignUp, data, headers);
            // console.log("response from signup", res);
            toast.success("Verify Your Email To Access your account");
            showLoader('none');
            myResolve(true);
        } catch (e) {
            let errorHandler = responseError(e);
            dispatch(ErrorAction(errorHandler));
            console.log('from auth action', errorHandler)
            showLoader('none');
            myReject(false);
        }
    });
};

// forgot password api 

export const ForgotPasswordApi = (data) => {
    // console.log("ForgotPassword data", data);
    showLoader('flex');
    return (dispatch) => new Promise(async (myResolve, myReject) => {
        try {
            let res = await axios.post(ForgotPassword, data, headersWithImage);
            // console.log("response from forgot api", res);
            showLoader("none");
            myResolve(res);
        } catch (e) {
            let errorHandler = responseError(e);
            showLoader('none');
            dispatch(ErrorAction(errorHandler));
            myReject(e);
        }
    })
}

// reset password api

export const ResetPasswordApi = (data) => {
    showLoader("flex");
    return (dispatch) => new Promise(async (myResolve, myReject) => {
        try {
            let res = await axios.post(ResetPassword, data, headers);
            showLoader("none");
            myResolve(res);
        } catch (e) {
            let errorHandler = responseError(e);
            showLoader("none");
            dispatch(ErrorAction(errorHandler));
            myReject(e)
        }
    })
}

// contact us page api

export const ContactApi = (data) => {
    // console.log("from contact api", data);
    showLoader('flex');
    return (dispatch) => new Promise(async (myResolve, myReject) => {
        try {
            let res = await axios.post(Contact, data, headers);
            // console.log("response from contact api", res);
            showLoader("none");
            myResolve(true);
        } catch (e) {
            let errorHandler = responseError(e);
            dispatch(ErrorAction(errorHandler));
            showLoader('none');
            myReject(false);
        }
    })
};

// news letter api

export const newsLetteApi = (data, user_token) => {
    showLoader("flex");
    return (dispatch) => new Promise(async (myResolve, myReject) => {
        try {
            let res = await axios.post(newsLetterUrl, data, headersWithToken(user_token));
            showLoader("none");
            myResolve(res);
        } catch (e) {
            let errorHandler = responseError(e);
            dispatch(ErrorAction(errorHandler));
            showLoader('none');
            myReject(e);
        }
    })
}

// update password api

export const UpdatePasswordApi = (data, reduxStateToken) => {
    // console.log(data, 'from update password api data auth action');
    return (dispatch) => new Promise(async (myResolve, myReject) => {
        try {
            let res = await axios.post(ChangePassword, data, headersWithToken(reduxStateToken));
            // console.log("response from signup", res);
            showLoader('none');
            myResolve(true);
        } catch (e) {
            let errorHandler = responseError(e);
            showLoader('none');
            dispatch(ErrorAction(errorHandler));
            myReject(false);
        }
    });
}

// tickers api

export const TickersGet = () => {
    // console.log("get ticker auth action working");
    return (dispatch) => new Promise(async (myResolve, myReject) => {
        try {
            let res = await axios.get(ShowTicker);
            // console.log("res from auth action", res);
            showLoader("none");
            myResolve(res);
        } catch (e) {
            let errorHandler = responseError(e);
            showLoader('none');
            dispatch(ErrorAction(errorHandler));
            myReject(false);
        }
    })
}

// podcast api

export const PodcastGet = () => {
    // console.log("get podcast working from");
    showLoader("flex");
    return (dispatch) => new Promise(async (myResolve, myReject) => {
        try {
            let res = await axios.get(ShowPodcast);
            showLoader("none");
            // console.log("res from auth action", res.data.response.data);
            myResolve(res.data.response.data);
        } catch (e) {
            showLoader("none");
            console.log('error from get podcast', e);
            myReject(false);
        }
    })
}

// podcast pagintation

export const PodCastByPagination = (url) => {
    // console.log("get podcast pagination ", url);
    showLoader("flex");
    return (dispatch) => new Promise(async (myResolve, myReject) => {
        try {
            let res = await axios.get(url);
            showLoader("none");
            // console.log("res from auth action", res.data.response.data);
            myResolve(res.data.response.data);
        } catch (e) {
            showLoader("none");
            console.log("error from podcastbypagination", e);
            myReject(e);
        }
    })
}

// single podcast

export const SinglePodcastApi = (id) => {
    // console.log("get single podcast", id.id);
    showLoader("flex");
    return (dispatch) => new Promise(async (myResolve, myReject) => {
        try {
            // console.log("workingg");
            let res = await axios.get(`${site_url}/showPodcast/${id.id}`);
            showLoader("none");
            myResolve(res);
        } catch (e) {
            console.log('from auth action ', e);
            myReject(false);
        }
    }
    )
}


// get podcast by click

export const GetPodCastbyClickApi = (id) => {
    // console.log("get prod by clikc", id);
    showLoader("flex");
    return (dispatch) => new Promise(async (myResolve, myReject) => {
        try {
            let res = await axios.get(`${site_url}/showPodcast/${id}`);
            showLoader("none");
            myResolve(res);
        } catch (e) {
            console.log('from auth action ', e);
            myReject(false);
        }
    })
}

// get all blogs


export const GetAllBlogs = () => {
    // console.log();
    showLoader("flex");
    return (dispatch) => new Promise(async (myResolve, myReject) => {
        try {
            let res = await axios.get(ShowBlog);
            showLoader("none");
            // console.log("res from auth action", res);
            myResolve(res);
        } catch (e) {
            showLoader("none");
            console.log("error from get all blogs", e);
            myReject(e);
        }
    })
}

// blogs by pagination

export const BlogsByPagination = (url) => {
    // console.log("get blogs pagination", url);
    showLoader("flex");
    return (dispatch) => new Promise(async (myResolve, myReject) => {
        try {
            let res = await axios.get(url);
            showLoader("none");
            // console.log("res from auth action", res);
            myResolve(res);
        } catch (e) {
            console.log("error from blogs by pagination", e);
            myReject(e);
        }
    })
}

// single blog

export const SingleBlogApi = (id) => {
    // console.log("single blog", id);
    showLoader("flex");
    return (dispatch) => new Promise(async (myResolve, myReject) => {
        try {
            let res = await axios.get(`${site_url}/showBlog/${id.id}`);
            showLoader("flex");
            // console.log("res from auth action", res);
            myResolve(res);
        } catch (e) {
            console.log("error from single blog api action", e);
            myReject(e);
        }
    })
}

// get all banner
export const GetAllBanner = () => {
    showLoader("flex");
    return (dispatch) => new Promise(async (myResolve, myReject) => {
        try {
            let res = await axios.get(`${site_url}/getBanner`);
            showLoader("none");
            myResolve(res);
        } catch (e) {
            console.log("from auth action catch", e);
            myReject(e);
        }
    })
}
// get all tips 

export const GetAllFreeTips = () => {
    // console.log("get all tips",id);
    showLoader("flex");
    return (dispatch) => new Promise(async (myResolve, myReject) => {
        try {
            let res = await axios.get(`${site_url}/tip/getFreeTip`);
            showLoader("none");
            // console.log("res from auth action", res);
            myResolve(res);
        } catch (e) {
            console.log("from auth action catch", e);
            myReject(e);
        }
    })
}

// get all premium tips

export const GetAllPrimumTipsApi = (token) => {
    // console.log("get all tips");
    showLoader("flex");
    return (dispatch) => new Promise(async (myResolve, myReject) => {
        try {
            let res = await axios.get(`${site_url}/user/getPremiumTip`, headersWithToken(token));
            showLoader("none");
            // console.log("res from auth action", res);
            myResolve(res);
        } catch (e) {
            showLoader("none");
            console.log("from auth action catch", e);
            myReject(e);
        }
    })
}

// tips by pagination

export const TipsByPagination = (url) => {
    // console.log("get all tips by pagination");
    showLoader("flex");
    return (dispatch) => new Promise(async (myResolve, myReject) => {
        try {
            let res = await axios.get(url);
            showLoader("none");
            // console.log("res from auth action", res);
            myResolve(res);
        } catch (e) {
            console.log("error from auth action", e);
            myReject(e);
        }
    })
}

// single tips api

export const getSingleTipApi = (id, is_Premium, user_token) => {

    let url_getData;
    if (is_Premium == 0) {
        url_getData = `${site_url}/tip/getFreeTip/${id}`;
    } else {
        url_getData = `${site_url}/user/getPremiumTip/${id}`;
    }
    // console.log("get single tips", url_getData);
    // console.log("get single tips", is_Premium);
    // console.log("get single tips", id);
    // console.log("get single tips", user_token);
    showLoader("flex");
    return (dispatch) => new Promise(async (myResolve, myReject) => {
        try {
            // console.log("workingg");
            let res = await axios.get(`${url_getData}`, headersWithToken(user_token));
            showLoader("none");
            myResolve(res);
        } catch (e) {
            console.log("error from auth action", e);
            myReject(false);
        }
    })
}


// testimonial api

export const getAllTestimonialsApi = () => {
    // console.log("get all testimonials");
    showLoader("flex");
    return (dispatch) => new Promise(async (myResolve, myReject) => {
        try {
            let res = await axios.get(showTestimonial);
            showLoader("none");
            // console.log("res from auth action", res);
            myResolve(res);
        } catch (e) {
            console.log("error from auth action", e);
            showLoader("none");
            myReject(e);
        }
    })
}

// logout api

export const LogoutApiDelToken = (token) => {
    // console.log("logout working from auth actions");

    return (dispatch) => new Promise(async (myResolve, myReject) => {
        try {
            let res = await axios.get(logoutDelToken, headersWithToken(token));
            // console.log("logout working from auth actions inside apicall", res);
            myResolve(res);
        } catch (e) {
            console.log("error from auth error", e);
            myReject(e);
        }
    })
}

// packages api

export const GetAllPackages = (token) => {
    showLoader("flex");
    return (dispatch, geState) => new Promise(async (myResolve, myReject) => {
        try {
            // let token = geState().auth.token;
            let res = await axios.get(ShowPackages, headersWithToken(token));
            myResolve(res.data.response);
        } catch (e) {
            console.log("error from auth error", e);
            myReject(e);
        }
    })
}
// packages pagination

export const GetPackageByPagination = (url) => {
    showLoader("flex");
    return (dispatch) => new Promise(async (myResolve, myReject) => {
        try {
            let res = await axios.get(url);
            // console.log('res from authaction', res);
            myResolve(res.data.response);
        } catch (e) {
            console.log("error from auth error", e);
            myReject(e);
        }
    })
}


// get all categories

export const GetAllCategories = () => {
    showLoader("flex");
    return (dispatch) => new Promise(async (myResolve, myReject) => {
        try {
            let res = await axios.get(showCategory);
            // console.log("res from auth action", res);
            myResolve(res);
        } catch (e) {
            console.log("error from auth error", e);
            myReject(e);
        }
    })
}

// get userCategories

export const GetUserCategories = (id) => {
    showLoader("flex");
    return (dispatch) => new Promise(async (myResolve, myReject) => {
        try {
            let res = await axios.get(`${site_url}/user-interest/getUserInterest/${id}`);
            // console.log("res from auth action", res);
            myResolve(res);
        } catch (e) {
            console.log("error form auth action", e);
            myReject(e);
        }
    })
}

//save first time categories

export const userInterestApi = (categoriesId, userId) => {
    // console.log('data sent from auth action catid', categoriesId)
    // console.log('usid auth action', userId)

    showLoader("flex");
    return (dispatch) => new Promise(async (myResolve, myReject) => {
        try {
            let res = await axios.post(`${site_url}/user-interest/storeUserInterest?category=${JSON.stringify(categoriesId)}&user_id=${userId}`);
            myResolve(res);
            // console.log(res);
            toast.success("Interests change successfully")
        } catch (e) {
            console.log("error from auth error", e);
            myReject(e);
        }
    })
}

// get site map

export const getSiteMapApi = () => {
    showLoader("flex");
    return (dispatch) => new Promise(async (myResolve, myReject) => {
        try {
            let res = await axios.get(getSiteMap, headers);
            // console.log(res);
            myResolve(res);
            showLoader("none");
        } catch (e) {
            console.log("error from auth error", e);
            myReject(e);
            showLoader("none");
        }
    })
}

// get site settings api
export const getSiteSettings = () => {
    showLoader("flex");
    return (dispatch) => new Promise(async (myResolve, myReject) => {
        try {
            let res = await axios.get(SiteSettingsUrl, headers);
            // console.log(res);
            myResolve(res);
            showLoader("none");
        } catch (e) {
            console.log("error from auth error", e);
            myReject(e);
            showLoader("none");
        }
    })
}

// venmo renew subscription
export const GetMyPackageApiCall = (token, data) => {
    showLoader("flex");
    return (dispatch) => new Promise(async (myResolve, myReject) => {
        try {
            let res = await axios.post(CurrentSubsUrl, data, headersWithToken(token));
            // console.log(res);
            myResolve(res);
            showLoader("none");
        } catch (e) {
            console.log("error from auth error", e);
            myReject(e);
            showLoader("none");
        }
    })
}